declare global {
  interface Window {
    __wlRecoveryToken?: string;
  }
}

export const readRecoveryToken = (): string | undefined => {
  if (/^\/reset-password\/*$/i.test(window.location.pathname) && window.location.hash) {
    const token = new URLSearchParams(window.location.hash.slice(1)).get('token') ?? '';
    window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    window.__wlRecoveryToken = token;
  }
  const token = window.__wlRecoveryToken;
  return token === undefined || /^[A-Za-z0-9_-]{43}$/.test(token) ? token : '';
};

export const clearRecoveryEntry = (): void => {
  delete window.__wlRecoveryToken;
};